import $ from 'jquery'
import { debounce, throttle } from './helpers'

// Selectors
const section = $('.features')
const firstVideo = $('.features-videos-inner-video').eq(0)
const videos = document.querySelectorAll('.features-videos-inner-video')

// State
let lastCurrent = -1

// Events
$(window).on(
  'scroll',
  throttle(function () {
    handleScroll()
  }, 10)
)

$(window).on(
  'resize',
  debounce(function () {
    handleScroll()
  }, 100)
)

// Functions
function handleScroll() {
  // Stop if not full size
  if ($('.features').css('display') !== 'flex') return

  const percentage = calculatePercentageThrough()

  //set new active stuff
  if (percentage > 0.63) {
    if (lastCurrent != 2) changePosition(2)
    lastCurrent = 2
  } else if (percentage > 0.31) {
    if (lastCurrent != 1) changePosition(1)
    lastCurrent = 1
  } else if (percentage > 0) {
    if (lastCurrent != 0) changePosition(0)
    lastCurrent = 0
  }
}

function calculatePercentageThrough() {
  // Calculations
  const videoHeight = firstVideo.height()
  const position = $(window).scrollTop() + $(window).height() - videoHeight + 40
  const start = section.offset().top + 40
  const length = section.height()
  const percentage = (position - start) / (length - videoHeight - 40)

  return percentage
}

function restartVideo(position) {
  const video = videos[position]
  video.pause()
  video.currentTime = 0
  video.play()
}

function changePosition(position) {
  // Toggle classes
  section.removeClass('features--no-active features--active0 features--active1 features--active2')
  section.addClass(`features--active${position}`)

  // Restart active video
  restartVideo(position)

  // First slide starts open
  if (lastCurrent === -1 && position === 0) {
    $('.features-text-section').eq(position).children('p').show()
    $('.features-text-section').eq(position).children('h2').css('font-size', 64)
  } else {
    $('.features-text-section p').slideUp()
    $('.features-text-section').eq(position).children('p').slideDown()

    $('.features-text-section').eq(lastCurrent).children('h2').animate({
      fontSize: 32,
    })

    $('.features-text-section').eq(position).children('h2').animate({
      fontSize: 64,
    })
  }
}

$('.features-text-section').on('click', function () {})
